/* eslint-disable no-continue */
import { FilteredActivities } from './getFilterActivities';

export function addSparkToReflection(
  filteredActivities: FilteredActivities[],
  reflections: (ReflectionEntity | undefined)[] | undefined,
  spark: SparkEntity
): ReflectionEntity[] {
  if (!reflections || reflections.length === 0) {
    return [];
  }

  const updatedReflections: ReflectionEntity[] = [];

  for (const reflection of reflections) {
    if (
      !reflection ||
      !reflection.project_process ||
      !reflection.project_process.process_id
    ) {
      updatedReflections.push(reflection!); // Add unchanged or undefined reflection to the updated array
      continue;
    }

    const processId = reflection.project_process.process_id;

    let matchedActivity: ActivityEntity | TrainingEntity | undefined;

    for (const filteredActivity of filteredActivities) {
      const matchedActivityInActivities = filteredActivity.activities?.find(
        (activity) => activity?.id === processId
      );
      if (matchedActivityInActivities) {
        matchedActivity = matchedActivityInActivities;
        break;
      }

      const matchedActivityInTrainings = filteredActivity.trainings?.find(
        (training) => training?.id === processId
      );
      if (matchedActivityInTrainings) {
        matchedActivity = matchedActivityInTrainings;
        break;
      }
    }

    if (!matchedActivity) {
      updatedReflections.push(reflection); // Add unchanged reflection to the updated array
      continue;
    }

    // Check if the reflection already has the spark
    const hasSpark = reflection.sparks.some(
      (existingSpark) => existingSpark.id === spark.id
    );

    if (!hasSpark) {
      // Add the spark to the reflection if it doesn't already exist
      reflection.sparks.push(spark);

      if (spark.related_sparks) {
        spark.related_sparks.forEach((relatedSpark) => {
          reflection.sparks.push(relatedSpark);
        });
      }
    }

    updatedReflections.push(reflection); // Add updated reflection to the updated array
  }

  return updatedReflections;
}
